// Remove unused axios import
// import axios from 'axios';
import { User } from '../types';
// Remove unused ApiResponse import
// import { ApiResponse } from '../types';

// Let's import the apiClient instead of axios
import apiClient from './api-client';
// Remove unused API_CONFIG import
// import API_CONFIG from '../config/api';

// Remove the API_URL definition since it's handled by apiClient
// const API_URL = process.env.REACT_APP_API_URL || '/api/v1';

// Define interfaces for API responses
interface LoginResponse {
  access_token: string;
  user_id?: string;
  name?: string;
  email?: string;
  role?: string;
  phone?: string;
}

interface UserProfileResponse {
  user_id?: string;
  name?: string;
  username?: string;
  email: string;
  role?: string;
  phone?: string;
}

// Login using form-urlencoded format as specified by the backend
export const loginApi = async (username: string, password: string): Promise<User> => {
  try {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);

    const response = await apiClient.post<LoginResponse, URLSearchParams>('/auth/login', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response && response.access_token) {
      // Store token
      localStorage.setItem('token', response.access_token);

      // Make ABSOLUTELY SURE that role is handled properly
      const userRole = response.role === 'admin' ? 'admin' : 'reseller';

      console.log('Login response data:', response);
      console.log('Login successful with determined role:', userRole);

      // Return user data
      return {
        id: response.user_id || '1',
        username: response.name || username,
        email: response.email || username,
        phone: response.phone || '',
        role: userRole,
        token: response.access_token,
      };
    }

    throw new Error('Invalid login response');
  } catch (error: any) {
    console.error('Login error:', error);

    // Handle common error status codes
    if (error.response?.status === 401) {
      throw new Error(
        'Ops! Não foi possível acessar sua conta. Verifique seu e-mail e senha e tente novamente.'
      );
    }

    // Re-throw the error with a friendly message
    throw new Error(
      'Ops! Não foi possível acessar sua conta. Verifique seu e-mail e senha e tente novamente.'
    );
  }
};

// Logout function
export const logout = (): void => {
  localStorage.removeItem('token');
};

// Check if user is authenticated
export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};

// Get current user profile using token
export const getCurrentUser = async (): Promise<User | null> => {
  const token = localStorage.getItem('token');

  if (!token) {
    return null;
  }

  try {
    // Add a flag to indicate this is a token validation request
    const response = await apiClient.get<UserProfileResponse>('/auth/me', {
      headers: {
        'X-Request-Type': 'token-validation',
      },
    });

    if (response) {
      const username = response.name || response.username || 'User';

      console.log('Raw ME endpoint response:', response);

      // Strict role validation - default to reseller unless explicitly set to admin
      let userRole = 'reseller';
      if (response.role === 'admin') {
        userRole = 'admin';
        console.log('User is ADMIN - role verified from backend');
      } else {
        console.log('User is RESELLER - either explicitly set or defaulted');
      }

      const user = {
        id: response.user_id || '1',
        username: username,
        email: response.email,
        phone: response.phone || '',
        role: userRole as 'admin' | 'reseller',
        token: token,
      };

      console.log('Final user object with role:', user);
      return user;
    }

    return null;
  } catch (error) {
    // The 401 error handling is now handled by apiClient's interceptors
    console.error('Error fetching user profile:', error);
    // Clear token if validation fails
    localStorage.removeItem('token');
    return null;
  }
};
